// @flow
import React from 'react';
import { withTheme } from '@material-ui/core/styles';

import { withTranslation } from 'react-i18next';

import { CircularProgress } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';

import ScribeTranscriptContainer from './ScribeTranscriptContainer';
import ScribeScrollWithTranscriptContainer from './ScribeScrollWithTranscriptContainer';
import ScribeCreateTranscriptContainer from './ScribeCreateTranscriptContainer';

import FinalTranscriptListContainer from './FinalTranscriptListContainer';

type State = {
  showLoadingCircle: boolean,
};

type Props = {
  currentPlatform: string,
  features: FeatureMap,
  fontSize: number,
  electronCaptionMode: boolean,
  inConferenceCall: boolean,
  lang: string,
  loaded: boolean,
  speakers: Object,
  status: Object,
  theme: Object,
  t: Function,
  transcriptsCurrent: Array<string>,
  transcriptsFinal: Array<string>,
  user: Object,
};

// Maybe have a finalized TranscriptsList component that only rerenders when
class ScribeTranscriptList extends React.Component<Props, State> {
  lastTranscript: ?HTMLElement;

  constructor(props: Props) {
    super(props)
    this.state = {
      showLoadingCircle: false
    }
  }

  setupRef(el: ?HTMLDivElement) {
    if (!el) return;

    this.lastTranscript = el;
  }

  shouldComponentUpdate(nextProps: Props) {
    const { loaded, status } = this.props;
    const { twilioCalls: nextTwilioCalls} = nextProps.status
    if (!nextProps.loaded && !loaded) {
      return false;
    }
    if (Object.keys(nextTwilioCalls).length === 1 && Object.keys(status.twilioCalls).length === 0) {
      const conferenceType = nextTwilioCalls[Object.keys(nextTwilioCalls)[0]]
      this.setState({
        showLoadingCircle: true,
      })
      if (conferenceType === 'zoom') {
        setTimeout(() => {
          this.setState({
            showLoadingCircle: false,
          })
        }, 10000)
      } else {
        setTimeout(() => {
          this.setState({
            showLoadingCircle: false,
          })
        }, 10000)
      }
    }
    return true;
  }

  render = () => {
    const {
      currentPlatform,
      features,
      fontSize,
      electronCaptionMode,
      inConferenceCall,
      lang,
      speakers,
      t,
      theme,
      transcriptsCurrent,
      transcriptsFinal,
      user,
    } = this.props;

    const { showLoadingCircle } = this.state

    return (
      <ScribeScrollWithTranscriptContainer>
        {transcriptsFinal.length !== 0 && (
          <div
            style={{
              padding: 24,
              paddingBottom: 0,
              position: 'relative',
              backgroundColor: theme.palette.background[theme.palette.type],
            }}
          >
            <div style={{ margin: '0 auto' }}>
              <FinalTranscriptListContainer
                features={features}
                lang={lang}
                transcriptsFinal={transcriptsFinal}
                user={user}
                fontSize={fontSize}
                currentPlatform={currentPlatform}
                speakers={speakers}
                theme={theme}
              />
            </div>
            {currentPlatform === 'scribe' && (
              <div
                style={{
                  position: 'absolute',
                  right: 0,
                  bottom: 0,
                  padding: '5px 10px',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <span
                  style={{
                    color: theme.palette.error.light,
                    fontSize: 24,
                  }}
                >
                  LIVE
                </span>
                &nbsp; &nbsp;
                <i
                  className="material-icons"
                  style={{
                    color: theme.palette.error.light,
                  }}
                >
                  wifi_tethering
                </i>
              </div>
            )}
          </div>
        )}
        {inConferenceCall && showLoadingCircle && (
          <div style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}>
            <CircularProgress
              color="secondary"
              style={{
                marginBottom: '12px',
            }} />
            <Typography>{t("conversation.call.joiningConferenceCall")}</Typography>
          </div>
        )}
        {transcriptsCurrent && transcriptsCurrent.length > 0 &&  (
          <div
            style={{
              background: theme.palette.background,
              paddingTop: 24,
              paddingLeft: window.isElectron && electronCaptionMode && !inConferenceCall ? 64 : 20,
              paddingRight: window.isElectron && electronCaptionMode ? 64 : 20,
              paddingBottom: 24,
            }}>
            <div style={{ margin: '0 auto' }}>
              {transcriptsCurrent.map((tid, i) => {
                // const transcript = transcripts[tid];
                const component = (
                  <div key={tid}>
                    <div style={{ position: 'relative' }}>
                      <div
                        ref={el =>
                          i === transcriptsCurrent.length - 1 &&
                          currentPlatform === 'web'
                            ? this.setupRef(el)
                            : null
                        }
                      >
                        <ScribeTranscriptContainer
                          id={tid}
                          key={tid}
                          // author={"Cale"}
                          // authorShow={transcript.authorShow}
                        />
                      </div>
                    </div>

                    {currentPlatform === 'scribe' &&
                      i === transcriptsCurrent.length - 1 && (
                        <ScribeCreateTranscriptContainer transcriptId={tid} />
                      )}
                  </div>
                );
                return component;
              })}
              {currentPlatform === 'scribe' &&
                transcriptsCurrent.length === 0 && (
                  <ScribeCreateTranscriptContainer transcriptId="" />
                )}
            </div>
          </div>
        )}
      </ScribeScrollWithTranscriptContainer>
    );
  };
}

export default withTranslation()(withTheme(ScribeTranscriptList));
